// userColumns.js
const resolveUserRole = (row) => row.role || row.rol?.name || 'Member';

export const userColumns = (navigate, modalConfirm, setModalConfirm, openRoleModal) => [
    {
        id: 'user',
        name: 'USER',
        minWidth: '220px',
        cell: (row) => (
            <div className="flex items-center gap-3">
                <img
                    src={row.imageProfile || "/images/usrAnonimo.png"}
                    alt={`${row.first_name} ${row.last_name}`}
                    className="w-9 h-9 rounded-full object-cover border border-cs-border"
                />
                <div className="flex flex-col">
                    <span className="text-sm font-semibold text-cs-dark leading-tight">
                        {row.first_name} {row.last_name}
                    </span>
                    <span className="text-[10px] text-cs-muted">
                        ID: {row.id}
                    </span>
                </div>
            </div>
        ),
    },
    {
        id: 'role',
        name: 'ROLE',
        selector: (row) => resolveUserRole(row),
        sortable: true,
        minWidth: '180px',
        cell: (row) => {
            const roleName = resolveUserRole(row);
            const canOpen = !!row.role_id;

            return canOpen ? (
                <button
                    type="button"
                    onClick={() => openRoleModal(row)}
                    className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-cs-primary-soft text-[10px] font-medium text-cs-primary-dark border border-cs-border hover:bg-cs-primary hover:text-white transition-all capitalize"
                    title="View role permissions"
                >
                    <span className="material-symbols-outlined text-[13px]">shield_person</span>
                    {roleName}
                </button>
            ) : (
                <span className="inline-flex px-2 py-1 rounded-full bg-cs-bg-alt text-[10px] font-medium text-cs-muted capitalize">
                    {roleName}
                </span>
            );
        },
    },
    {
        id: 'email',
        name: 'EMAIL',
        selector: (row) => row.email,
        sortable: true,
        minWidth: '200px',
        cell: (row) => (
            <span className="text-xs text-cs-dark truncate">
                {row.email}
            </span>
        ),
    },
    {
        id: 'status',
        name: 'STATUS',
        sortable: true,
        minWidth: '110px',
        cell: (row) => (
            <span
                className={`
          inline-flex items-center px-2 py-1 rounded-full
          text-[10px] font-medium
          ${row.active
                        ? 'bg-cs-success/10 text-cs-success'
                        : 'bg-cs-danger/10 text-cs-danger'}
        `}
            >
                <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5" />
                {row.active ? 'Active' : 'Inactive'}
            </span>
        ),
    },
    {
        id: 'actions',
        name: '',
        right: true,
        minWidth: '130px',
        cell: (row) => {
            const canDelete = !!row.can?.delete;

            return (
                <div className="flex items-center justify-end gap-2">
                    {/* Edit */}
                    <button
                        onClick={() => navigate(`/team-upadd/${row.id}`)}
                        className="
              p-1.5 rounded-lg
              hover:bg-cs-primary-soft
              text-cs-muted hover:text-cs-primary
              transition-colors
            "
                        title="Edit user"
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            edit
                        </span>
                    </button>

                    {/* Delete */}
                    <button
                        onClick={() =>
                            canDelete &&
                            setModalConfirm({
                                ...modalConfirm,
                                show: true,
                                id: row.id,
                            })
                        }
                        disabled={!canDelete}
                        className={`
              p-1.5 rounded-lg transition-colors
              ${canDelete
                                ? 'hover:bg-cs-primary-soft text-cs-danger hover:text-cs-danger'
                                : 'opacity-40 cursor-not-allowed text-cs-muted'
                            }
            `}
                        title="Delete user"
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            delete
                        </span>
                    </button>
                </div>
            );
        },
    },
];
